export var PopoverTriggerOn;
(function (PopoverTriggerOn) {
    PopoverTriggerOn["click"] = "click";
    PopoverTriggerOn["mouseover"] = "mouseover";
})(PopoverTriggerOn || (PopoverTriggerOn = {}));
